export const subscriptionConstants = {
  SUBSCRIPTION_PRICES: "SUBSCRIPTION_PRICES",
};

export const subscriptionUserTypeEmun = {
  FREELANCE: 7,
  CENTER: 6,
  PRACTITIONER: 3,
};
